export default "__VITE_ASSET__BjA$kElU__"